import ConfirmPassword from './ConfirmPasswordContainer';

export default ConfirmPassword;
